import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { aiContentRouteSearchSchema } from '@pages/crm';
import type { RouterContext } from '@shared/config/router-context';

export const Route = createFileRoute('/$locale/_authenticated/crm/helpdesk/prompts')({
  validateSearch: aiContentRouteSearchSchema,
  beforeLoad: ({ context, params }) => {
    const { auth, ability } = context as RouterContext;
    if (auth.isLoading || !auth.isAuthenticated) return;
    if (!ability.can('read', 'HelpdeskAiPrompt')) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/$locale/unauthorized', params: { locale: params.locale } });
    }
  },
  component: Outlet,
});
